/**
 * TmdbFooter — the single, standardized TMDB attribution used at the bottom of
 * every screen. Wide gold logo + one consistent caption.
 *
 * Reuses the existing `.tmdb-inline` styling so it matches the prior per-screen
 * attribution; pass an extra className for screen-specific spacing tweaks.
 */
export default function TmdbFooter({ className = '' }) {
  return (
    <a
      href="https://www.themoviedb.org"
      target="_blank"
      rel="noopener noreferrer"
      className={`tmdb-inline${className ? ' ' + className : ''}`}
    >
      <span className="tmdb-inline__label">Data provided by</span>
      <img src="/TMDB_LONG_GOLD.png" alt="The Movie Database" className="tmdb-shimmer" draggable={false} />
    </a>
  )
}
